import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from "moment-timezone";
import AssignDriversDialog from "../../Common/AssignDriversDialog";
import ReportDetails from './ReportDetails';
import EmailsDialog from "./EmailsDialog";
import t from "../../../languages/pl";

const initialState = {
    cykl: 0,
    email: [],
    lista_aut: [],
    nazwa: "",
    nazwa_pliku: "",
    raport_id: 0,
    typ: "",
    typ_id: 0,
    warunki: "",
    startTime: moment().startOf('week').unix(),
    endTime: moment().unix(),
    isAutomatic: false
};

const ReportDetailsWithDrivers = props => {
    const { title, report, open, onClose, onSubmit, autoEnable = false, isEdit = false, availableDrivers, isNew, typeId, option } = props;
    const [state, setState] = useState(initialState);
    const [emailsOpen, setEmailsOpen] = useState(false);
    const [dataToSend, setDataToSend] = useState(null);
    const [checkedOption, setCheckedOption] = useState(1);
    const [driverList, setDriverList] = useState([]);

    const dialogTitle = t.toReport + " " + title;

    useEffect(() => {
        if (typeId) {
            setState({
                ...state,
                typ_id: typeId
            });
        }
    }, [typeId]);

    useEffect(() => {
        if (report) {
            setState(report);
            if (isEdit) {
                setCheckedOption(report.wybor);
                if (report.wybor === 1) {
                    setDriverList(report.wybor_dane);
                }
            }
        }
    }, [report]);

    useEffect(() => {
        if (option) {
            setCheckedOption(option);
        }
    }, [option]);

    const handleSubmit = (driverIds) => {
        if(!isEdit){
            setDataToSend({
                nazwa: state.nazwa ? state.nazwa : "",
                nazwapliku: state.nazwa_pliku ? state.nazwa_pliku : "",
                typ_id: typeId,
                cykl: state.isAutomatic ? state.cykl : null,
                data_od: state.isAutomatic ? null : state.startTime,
                data_do: state.isAutomatic ? null : state.endTime,
                wybor: checkedOption,
                wybor_dane: checkedOption === 3 ? null : driverIds,
                warunki: state.conditions ? state.conditions : null
            });
            setEmailsOpen(true);
        }
        else {
            onSubmit && onSubmit({
                nazwa: state.nazwa ? state.nazwa : "",
                nazwapliku: state.nazwa_pliku ? state.nazwa_pliku : "",
                typ_id: state.typ_id,
                cykl: state.cykl,
                data_od: null,
                data_do: null,
                wybor: checkedOption,
                wybor_dane: checkedOption === 3 ? null : driverIds,
                warunki: state.conditions ? state.conditions : null,
                plik_id: null,
                email: state.email
            });
            onClose();
        }
    };

    const handleEmailSubmit = (emails) => {
        if(!isEdit){
            setEmailsOpen(false);
            onSubmit && onSubmit({
                ...dataToSend,
                email: emails
            });
        }else{
            setEmailsOpen(false);
            setState({
                ...state,
                email: emails
            });
            setEmailsOpen(false);
        }
    };

    const handleReportDetailsChange = (e) => {
        setState({
            ...state,
            [e.target.name]: e.target.value
        });
    };

    const handleRadioChange = (value) => {
        setCheckedOption(parseInt(value));
    };

    return (
        <AssignDriversDialog
            title={dialogTitle}
            open={open}
            onClose={onClose}
            onSubmit={handleSubmit}
            availableDrivers={availableDrivers}
            driversInGroup={driverList}
            checkedOption={checkedOption}
        >
            <ReportDetails
                autoEnable={autoEnable}
                reportName={state.nazwa ? state.nazwa : ""}
                reportFilename={state.nazwa_pliku}
                typeId={state.typ_id}
                cycle={state.cykl}
                startTime={state.startTime}
                endTime={state.endTime}
                onChange={handleReportDetailsChange}
                isEdit={isEdit}
                onEmailsEdit={() => setEmailsOpen(true)}
                isNew={isNew}
                withDrivers
                checkedOption={checkedOption}
                onRadioChange={handleRadioChange}
            />
            <EmailsDialog
                open={emailsOpen}
                onClose={() => setEmailsOpen(false)}
                onSubmit={handleEmailSubmit}
                inputEmails={state.email}
            />
        </AssignDriversDialog>
    );
};

ReportDetailsWithDrivers.propTypes = {
    title: PropTypes.string,
    report: PropTypes.object,
    open: PropTypes.bool,
    isEdit: PropTypes.bool,
    autoEnable: PropTypes.bool,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
    availableDrivers: PropTypes.array,
    startTime: PropTypes.number,
    endTime: PropTypes.number,
    isNew: PropTypes.bool,
    typeId: PropTypes.number,
    option: PropTypes.number,
};

export default ReportDetailsWithDrivers;
